import React from 'react'
import { IPowerOnTime } from '../store/ekgImport.types'
import { formatISOToDate, formatISOToTime, formatReceivedTime } from '../../../utilities/ekgImport.util'
import { useSelector } from 'react-redux'
import { getEKGImportSelector } from '../selectors'
import powerOnIcon from '../data/PowerOnIcon.svg'
import cloudUploadIcon from '../data/CloudUploadIcon.svg'

export interface IPowerOnTimeCardProps {
  powerOnTime: IPowerOnTime | null
  handleSelect?: (powerOnTime: IPowerOnTime) => void
}

const PowerOnTimeCard = (props: IPowerOnTimeCardProps) => {
  const { powerOnTime, handleSelect } = props

  const { monitorOptions } = useSelector(getEKGImportSelector)

  const renderMonitorName = (monitorSerial: string): string => {
    const monitor = monitorOptions.find((monitorOption) => monitorOption.monitorSerial === monitorSerial)

    if (!monitor) return monitorSerial
    else return monitor.name || monitorSerial
  }

  const onSelect = (powerOnTime: IPowerOnTime) => {
    if (handleSelect) handleSelect(powerOnTime)
  }

  if (!powerOnTime) return <></>

  return (
    <div
      className='pots-item'
      onClick={() => {
        onSelect(powerOnTime)
      }}>
      <div className='pots-item-power-on'>
        <div className='pots-item-power-on-time-icon'>
          <img src={powerOnIcon} alt='' />
        </div>
        <p className='pots-item-power-on-date'>{formatISOToDate(powerOnTime.powerOn)}</p>
        <p className='pots-item-power-on-time'>{formatISOToTime(powerOnTime.powerOn)}</p>
      </div>
      <div className='pots-item-monitor-info'>
        <div>
          <label className='pots-item-monitor-info-header'>{renderMonitorName(powerOnTime.monitorSerial)}</label>
          <label className='pots-item-monitor-info-subheader'>
            {powerOnTime.deviceType} {powerOnTime.patientName && ` - ${powerOnTime.patientName}`}
          </label>
        </div>

        <label className='pots-item-monitor-info-received-date'>
          <div className='pots-item-monitor-info-received-date-icon'>
            <img src={cloudUploadIcon} alt='' />
          </div>
          {formatReceivedTime(powerOnTime.dateReceived)}
        </label>
      </div>
    </div>
  )
}

export default PowerOnTimeCard
